import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
	selector: '[goDialogContent]',
	standalone: true
})
export class GoDialogContentDirective {
	@Input() public goDialogContentAriaLabelledBy?: string | null;
	@Input() public goDialogContentAriaLabel?: string | null;

	@HostBinding('attr.role')
	protected readonly role = 'dialog';

	@HostBinding('attr.aria-modal')
	protected readonly ariaModal = 'true';

	@HostBinding('attr.aria-labelledby')
	protected get ariaLabelledBy (): string | null {
		return this.goDialogContentAriaLabelledBy ?? null;
	}

	@HostBinding('attr.aria-label')
	protected get ariaLabel (): string | null {
		if (this.goDialogContentAriaLabelledBy != null) {
			return null;
		}

		return this.goDialogContentAriaLabel ?? null;
	}
}
